







import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'TextSection',
  props: {
    title: String,
    content: String,
  },
});
